// This is used to map any API responses to camelCase and is unit tested
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const camelCaser = (input: any): any => {
  if (typeof input === 'object' && !Array.isArray(input)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clone: any = {};
    for (const property in input) {
      const newProperty = `${property
        .slice(0, 1)
        .toLowerCase()}${property.slice(1)}`;
      if (
        typeof input[property] === 'object' ||
        Array.isArray(input[property])
      ) {
        clone[newProperty] = camelCaser(input[property]);
      } else {
        clone[newProperty] = input[property];
      }
    }
    return clone;
  } else if (Array.isArray(input)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clone: any[] = [];
    for (const item of input) {
      clone.push(camelCaser(item));
    }
    return clone;
  }
  return input;
};

const camelToSnake = (str: string): string => {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
    .toLowerCase();
};

export const snakeToCamel = (str: string): string => {
  return str.replace(/(_[a-z])/g, g => g[1].toUpperCase());
};

export const convertKeysToSnakeCase = (obj: Record<string, unknown>): Record<string, unknown> => {
  const result: Record<string, unknown> = {};

  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const newKey = camelToSnake(key);
      result[newKey] = obj[key];
    }
  };

  return result;
};

export const convertKeysToCamelCase = (obj: Record<string, unknown>): Record<string, unknown> => {
  const result: Record<string, unknown> = {};

  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const newKey = snakeToCamel(key);
      result[newKey] = obj[key];
    }
  };

  return result;
};
